// brand pages 
class GroupedList extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.groupedData = null;
        this.showImage = false;
    }

    static get observedAttributes() {
        return ['data', 'show-image'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data') {
            this.data = JSON.parse(newValue);
        }
        if (name === 'show-image') {
            this.showImage = newValue === 'true';
            this.render();
        }
    }

    set data(value) {
        this._data = value;
        this.groupedData = this.groupData(this._data);
        this.render();
    }

    groupData(data) {
        return Object.values(data.reduce((r, e) => {
            let group = e.name[0].toUpperCase();
            if (!r[group]) r[group] = { group, children: [e] };
            else r[group].children.push(e);
            return r;
        }, {}));
    }

    render() {
        if (!this.groupedData) return;

        const groupKeys = Object.keys(this.groupedData.reduce((acc, group) => {
            acc[group.group] = true;
            return acc;
        }, {}));

        const contentFlexDirection = this.showImage ? 'block' : 'grid';
        const groupFlexDirection = this.showImage ? 'row' : 'column';
        const hideHeader = this.showImage ? "flex" : "none";
        const tableBorder = this.showImage ? "none" : "solid grey 1px"

        this.shadowRoot.innerHTML = `
            <style>
               #content {
                    overflow-y: auto;
                    scroll-behavior: smooth;
                    display: ${contentFlexDirection};
                    grid-template-columns: repeat( auto-fit, minmax(150px, 1fr) );
                }
                .letter-list {
                    display: ${hideHeader};
                    flex-wrap: wrap;
                    margin-bottom: 20px;
                    justify-content: center;
                    padding: 1rem 0;
                    row-gap: 1rem;
                    background: #f7f7f7!important;
                }
                .letter-list a {
                    margin-right: 10px;
                    cursor: pointer;
                    font-size: calc(var(--base-text-font-size) - (var(--default-text-font-size) - 21px));
                    text-decoration: none;
                    color: var(--heading-color);
                }
                .group {
                    display: flex;
                    flex-direction: row;
                    gap: 1rem;
                    margin-bottom: 1rem;
                }
                .group-name {
                    font-weight: bold;
                    font-size: 1.2em;
                    margin-bottom: 10px;
                    border-block: ${tableBorder};
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                }
                .name-container {
                    width: 20px;
                }
                .items-container {
                   display: grid;
                   grid-template-columns: repeat(auto-fill, 150px);
                   gap: 1rem;
                   width: 100%;
                }
                .item {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #e9e9e9;
                    aspect-ratio: 1 / 1;
                    min-width: 130px;
                    justify-content: end;
                    align-items: center;
                }

                .card {
                    background: var(--secondary-background);
                    border-top: 1px solid var(--border-color);
                    border-bottom: 1px solid var(--border-color);
                }
                .item a {
                    text-decoration: none;
                }
                .item img {
                    mix-blend-mode: multiply;
                }
                .item h3 {
                    font-weight:700;
                    font-size: 16px;
                    text-decoration: none;
                    color: #000;
                    margin: 0;
                    text-align: center;
                }

                .letters {
                    border: 1.5px solid var(--border-color);
                    width: 40px;
                    height: 25px;
                    margin-right: 9px;
                    line-height: 25px;
                    font-size: 12px;
                    text-align: center;
                }
                    
                .letter-list a {
                    margin-right: 10px;
                    cursor: pointer;
                    font-size: calc(var(--base-text-font-size) - (var(--default-text-font-size) - 21px));
                    text-decoration: none;
                    color: var(--heading-color);
                }

                .letters:hover {
                    background-color: var(--heading-color);
                    color: #fff;
                    border-color: var(--heading-color);
                }

                @media only screen and (max-width: 768px) {
                    .grid {
                        padding: 0 1rem;
                    }
                    .letter-list {
                        padding 0 2rem;
                        background: #f7f7f7;
                    }
                    .items-container {
                        overflow-x: scroll;
                        flex-wrap: nowrap;
                        display: flex;
                    }
                    .item {
                        min-width: 130px;
                        padding: 5px;
                    }
                }       

            </style>
            <div class="grid">
                <div class="letter-list card">
                    ${groupKeys.map(letter => `<a href="#group-${letter}" class="letters" data-letter="${letter}">${letter}</a>`).join('')}
                </div>
                <div class="card" id="content"></div>
            </div>
        `;

        const contentDiv = this.shadowRoot.getElementById('content');

        this.groupedData.forEach(group => {
            const groupDiv = document.createElement('div');
            groupDiv.classList.add('group');
            groupDiv.id = `group-${group.group}`;

            // Create a div for the group name
            const groupNameContainer = document.createElement('div');
            groupNameContainer.classList.add('name-container');
            const groupName = document.createElement('div');
            groupName.classList.add('group-name');
            groupName.textContent = group.group;
            groupNameContainer.appendChild(groupName);
            groupDiv.appendChild(groupNameContainer);  // Append the group name

            // Create a single container for all items
            const itemsContainer = document.createElement('div');
            itemsContainer.classList.add('items-container');

            group.children.forEach(item => {
                const itemDiv = document.createElement('div');
                itemDiv.classList.add('item');

                const link = document.createElement('a');
                link.href = item.link ? item.link : '/';
                link.classList.add('flex-col');

                if (this.showImage) {
                    const image = document.createElement('img');
                    image.src = `${item.image}`;
                    image.classList.add('center');
                    if (!item.image.includes('no-image')) {
                        link.appendChild(image);
                    }
                }

                const name = document.createElement('h3');
                name.classList.add('tw-text-black', 'tw-bolder');
                name.textContent = item.name;

                link.appendChild(name);
                itemDiv.appendChild(link);

                itemsContainer.appendChild(itemDiv);  // Append each itemDiv to the single items container
            });

            groupDiv.appendChild(itemsContainer);  // Append the items container to the groupDiv

            contentDiv.appendChild(groupDiv);  // Finally append the entire groupDiv to the content
        });


        this.shadowRoot.querySelectorAll('.letter-list a').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                const letter = anchor.getAttribute('data-letter');
                const targetGroup = this.shadowRoot.getElementById(`group-${letter}`);
                if (targetGroup) {
                    targetGroup.scrollIntoView({ behavior: 'smooth', block: "center" });
                }
            });
        });
    }

}
customElements.define('grouped-list', GroupedList);